import { isApiError } from '@/services/api';
import { normalisePricedBasket } from '../services/basketPricing';
import type { PricedBasket } from '../types/basketPricing.types';

/** Save/completion refusal codes smr/quote-service can attach to a pricing failure. */
export const PRICING_UNAVAILABLE = 'pricing_unavailable';
export const PRICING_REJECTED = 'pricing_rejected';

/** The SMRiQ session has expired (1800s TTL) or was never generated. */
export const SERVICE_PLAN_SESSION_EXPIRED = 'service_plan_session_expired';
export const SERVICE_PLAN_SESSION_REQUIRED = 'service_plan_session_required';

/** A pricing refusal that retrying the same request cannot clear — the session is gone
 *  from Redis, so only regenerating the plan (SmriqConfigurator) can recover. */
export const isUnrecoverablePricingError = (error: unknown): boolean =>
    isApiError(error) &&
    error.status === 422 &&
    (error.code === SERVICE_PLAN_SESSION_EXPIRED || error.code === SERVICE_PLAN_SESSION_REQUIRED);

/** The fresh `pricing` block from a `price_changed` 422, or null for any other error.
 *  `ApiErrorRenderer` merges it at the top level beside `error`, never under `data`. */
export const priceChangedBlock = (error: unknown): PricedBasket | null => {
    if (!isApiError(error) || error.status !== 422 || error.code !== 'price_changed') {
        return null;
    }
    const raw = (error.data as Record<string, unknown> | undefined)?.pricing;
    if (raw === undefined) {
        return null;
    }
    try {
        return normalisePricedBasket(raw);
    } catch {
        return null;
    }
};
